/**
 * L4: Show in Large Type (01-references §6 S7): one value, full screen, one box per character
 * with its position underneath, for typing a password on another device. Digits and symbols are
 * coloured so 0/O and 1/l are told apart. It shares the reveal deadline, so it closes on its own
 * after 30 s, on lock, and when the app goes to the background.
 */
import { splitFieldRef, type AppActions, type AppState } from "../contract.js";
import { h } from "../shell/dom.js";
import { isRevealed } from "../detail/reveal.js";
import { copyValue } from "../vm/detail.js";

export function charClass(ch: string): "digit" | "letter" | "symbol" {
  if (/[0-9]/.test(ch)) return "digit";
  if (/\p{L}/u.test(ch)) return "letter";
  return "symbol";
}

export function renderLargeType(state: AppState, actions: AppActions): HTMLElement | null {
  const ref = state.largeType;
  if (!ref || !isRevealed(state.revealed, ref, state.now)) return null;
  const { itemId, fieldId } = splitFieldRef(ref);
  const item = state.snapshot?.items.find((i) => i.id === itemId);
  const field = item?.fields.find((f) => f.id === fieldId);
  if (!item || !field) return null;
  const value = copyValue(field, state.now);
  return h(
    "div",
    { class: "large-type", role: "dialog", "aria-label": `${item.title} ${field.label} in large type`, onclick: () => actions.closeLargeType() },
    h(
      "div",
      { class: "lt-chars" },
      ...[...value].map((ch, i) => h("div", { class: `lt-char ${charClass(ch)}` }, h("span", { class: "lt-glyph" }, ch === " " ? "␣" : ch), h("span", { class: "lt-index" }, i + 1))),
    ),
    h("p", { class: "lt-caption" }, `${item.title} · ${field.label}`, h("br"), "Tap anywhere to close"),
  );
}
